/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2019/3/12
 * Time: 16:05
 */
import _ from 'lodash'

export default class MessageCache {
  constructor (key) {
    if (!key) throw new Error('Key is a necessary parameter.')
    this.key = key
    this.cache = {}
    this.cache[key] = []
  }

  register (message) {
    if (!message.id) throw new Error('id is a necessary data.')
    this.cache[this.key].push(message)
  }

  get (uuid) {
    return uuid ? this.cache[this.key].find(item => uuid === item.id) : this.cache[this.key]
  }

  remove (uuid) {
    console.log('删除前的cache', _.cloneDeep(this.cache[this.key]))
    const index = this.cache[this.key].findIndex(item => uuid === item.id)
    this.cache[this.key].splice(index, 1)
    console.log('删除后的cache', this.cache[this.key])
  }

  exist (uuid) {
    return this.cache[this.key].some(item => item.uuid === uuid)
  }

  createUuid () {
    let d = new Date().getTime()
    let base = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'

    if (window.performance && typeof window.performance.now === 'function') {
      // use high-precision timer if available
      d += performance.now()
    }

    return base.replace(/[xy]/g, c => {
      let r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
  }
}



// WEBPACK FOOTER //
// ./src/cache/index.js